import React from "react";
import {menuItemsInfo} from "../editMenuItems";
import {SectionHeader} from "../components/EditMenuSection";
import {MessageListEditor} from "../components/MessageListEditor";

export const PleaseWaitMessagesTab = ({node, setNode, onUpdate}) => {
    const messages = node?.data?.please_wait_messages || [];

    const onChangeMessage = (index, value) => {
        const state = {...node};
        if (state.data.please_wait_messages[index] !== value) {
            state.data.please_wait_messages[index] = value;
            setNode(state);
        }
    };

    const removeMessage = async (index) => {
        const state = {...node};
        state.data.please_wait_messages = state.data.please_wait_messages?.filter((msg, ind) => ind !== index);
        await onUpdate(state);
    };

    const addMessage = async () => {
        const state = {...node};
        if (!state?.data?.please_wait_messages?.length || state?.data?.please_wait_messages?.length === 0) {
            state.data.please_wait_messages = [];
        }
        state.data.please_wait_messages = [...state.data.please_wait_messages, ""];
        await onUpdate(state);
    };

    const {primary, secondary} = menuItemsInfo.please_wait_messages;

    return (
        <>
            <SectionHeader title={primary} description={secondary}/>
            <MessageListEditor
                messages={messages}
                onChange={onChangeMessage}
                onCommit={() => onUpdate(node)}
                onRemove={removeMessage}
                onAdd={addMessage}
                addLabel="Add message"
                emptyLabel="No wait messages yet."
            />
        </>
    );
};
